import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ArrowRight, Video } from "lucide-react";
import { setPageSeo } from "../lib/seo";

const BOOKING_EMBED_URL =
  process.env.REACT_APP_BOOKING_EMBED_URL ||
  process.env.REACT_APP_CALENDLY_URL ||
  "https://cal.com/devz-corner/30min?embed=true";

export default function BookCall() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageSeo({
      title: "Book a Discovery Call — Devzcorner",
      description:
        "Schedule a 30-minute discovery call with Devzcorner to discuss software, AI, hardware, or 3D product development.",
      path: "/book-call",
    });
  }, []);

  return (
    <main className="relative bg-ink-0 text-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-24 px-6 md:px-10 max-w-5xl mx-auto w-full">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-accent-cyan/10 border border-accent-cyan/20 text-accent-cyan mb-6">
            <Video size={28} strokeWidth={1.5} />
          </div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6">
            Let's discuss your project.
          </h1>
          <p className="text-zinc-400 text-lg md:text-xl font-light max-w-2xl mx-auto leading-relaxed">
            Book a free 30-minute discovery call to explore how DevzCorner can help build your next software or AI product.
          </p>
        </div>

        {/* Cal.com / Calendly Embed */}
        <div className="glass-card rounded-3xl border border-white/10 p-2 md:p-4 min-h-[620px] bg-ink-50 relative overflow-hidden">
          <div className="absolute inset-0 tech-grid-fine opacity-20 pointer-events-none" />
          {BOOKING_EMBED_URL ? (
            <iframe
              src={BOOKING_EMBED_URL}
              title="Book a discovery call"
              loading="lazy"
              className="relative z-10 w-full h-[620px] rounded-2xl border border-white/10 bg-ink-0"
              frameBorder="0"
              allow="camera; microphone; fullscreen; clipboard-read; clipboard-write"
            />
          ) : (
            <div className="text-center z-10 p-8 h-[620px] flex flex-col items-center justify-center">
              <h3 className="text-xl font-display text-white mb-2">Calendar Embed Placeholder</h3>
              <p className="text-zinc-500 text-sm max-w-sm mx-auto mb-6">
                To activate this booking page, set REACT_APP_BOOKING_EMBED_URL
                with your Cal.com or Calendly iframe URL.
              </p>
              <a
                href="mailto:hello@devzcorner.com"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-black text-sm font-semibold hover:bg-zinc-200 transition-all"
              >
                Or email us directly
                <ArrowRight size={16} strokeWidth={2.5} />
              </a>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </main>
  );
}
